import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { fehServicesStoreSelectorKey, reducers } from './feh-services.state';

@NgModule({
  imports: [StoreModule.forFeature(fehServicesStoreSelectorKey, reducers)],
})
export class FehServicesStoreModule {}
